var exports = {
  "Qs": "AddConnectionModal.module__content___b0tBLW",
  "t$": "AddConnectionModal.module__stack___b0tBLW",
  "GA": "AddConnectionModal.module__instructions___b0tBLW",
  "G5": "AddConnectionModal.module__dnsCard___b0tBLW",
  "KJ": "AddConnectionModal.module__dnsHeading___b0tBLW",
  "Eq": "AddConnectionModal.module__dnsTitle___b0tBLW",
  "h_": "AddConnectionModal.module__dnsFields___b0tBLW",
  "ti": "AddConnectionModal.module__inlineCode___b0tBLW",
  "_c": "AddConnectionModal.module__dnsInput___b0tBLW",
  "x": "AddConnectionModal.module__orDivider___b0tBLW",
  "LC": "AddConnectionModal.module__orDividerLine___b0tBLW",
  "AS": "AddConnectionModal.module__orDividerText___b0tBLW",
  "iW": "AddConnectionModal.module__tokenCard___b0tBLW",
  "TN": "AddConnectionModal.module__tokenCardHeader___b0tBLW",
  "q6": "AddConnectionModal.module__tokenTitle___b0tBLW",
  "wc": "AddConnectionModal.module__tokenSubtitle___b0tBLW",
  "OB": "AddConnectionModal.module__tokenDownloadRow___b0tBLW",
  "RB": "AddConnectionModal.module__tokenMeta___b0tBLW",
  "cL": "AddConnectionModal.module__copyButton___b0tBLW",
  "nJ": "AddConnectionModal.module__copyIcon___b0tBLW",
};

module.exports = exports;
